import React, {Fragment, useState, useRef, useImperativeHandle} from 'react';

import UserInput from "ui/ReactUserInput";
import UserInputCheckbox from "ui/ReactUserInputCheckbox";
import FieldsetContainer from "root/Base/FieldsetContainer";
import BootstrapRow from "ui/BootstrapRow";
import {useChildContext} from "root/Contexts/ChildContext";
import BootstrapCol from "ui/BootstrapCol";

export const emptyRiskOfExclusionData = {
   risk_of_exclusion_flag: 0,
   dmy_risk_of_exclusion_date: null
}

const RiskOfExclusionForm = React.forwardRef(({readOnly, displayErrors, child}, ref) =>
{
   const { isPost16 } = useChildContext();

   const initialisAtRiskOfExclusionFlag = +(child.risk_of_exclusion_flag) === 1;

   const [isAtRiskOfExclusionFlag, setisAtRiskOfExclusionFlag] = useState(initialisAtRiskOfExclusionFlag)

   const InputRiskOfExclusion = useRef(null);
   const InputRiskOfExclusionStartDate = useRef(null);

   useImperativeHandle(ref, () => ({
      getFormData()
      {
         return getFormDataLocal();
      },
      formIsValid()
      {
         return formIsValidLocal();
      },
   }))

   const getFormDataLocal = () =>
   {
      return (
         {
            risk_of_exclusion_flag: isAtRiskOfExclusionFlag ? 1 : 0,
            dmy_risk_of_exclusion_date: isAtRiskOfExclusionFlag ? InputRiskOfExclusionStartDate.current.getValue() : null,
         }
      )
   }

   const formIsValidLocal = () =>
   {
      let valid = true;

      if (isAtRiskOfExclusionFlag)
      {
         if (!InputRiskOfExclusionStartDate.current.isValid())
         {
            valid = false;
         }
      }

      return valid;
   }

   const onChangeRiskOfExclusion = (newValue) =>
   {
      setisAtRiskOfExclusionFlag(newValue);
   }

   const fromDateRow = () =>
   {
      const fromRequired = isAtRiskOfExclusionFlag === true;

      return (
         <Fragment>
            <div key='sastart' className='col-md-6'>
               {isAtRiskOfExclusionFlag === true &&
                  <UserInput validation={{required: fromRequired, maxlen: 10, isDate: true}}
                             id='InputRiskOfExclusionStartDate'
                             name='InputRiskOfExclusionStartDate'
                             key='InputRiskOfExclusionStartDate'
                             ref={InputRiskOfExclusionStartDate}
                             placeholder='DD/MM/YYYY'
                             labelText='Date Recorded'
                             errorText='You must enter a valid date'
                             value={child.dmy_risk_of_exclusion_date}
                             readOnly={readOnly}
                             displayErrors={displayErrors}/>}
            </div>
         </Fragment>
      )
   }

   const isRiskOfExclusionSection = () =>
   {
      return (
         <Fragment>
            <div key='' className='col-md-6'>
               <UserInputCheckbox
                  key='InputRiskOfExclusion'
                  ref={InputRiskOfExclusion}
                  label='Is the child at risk of Permanent Exclusion'
                  errorText='Is the child at risk of Permanent Exclusion'
                  defaultValue={initialisAtRiskOfExclusionFlag}
                  readOnly={readOnly}
                  onChange={onChangeRiskOfExclusion}
                  displayErrors={displayErrors}/>
            </div>
         </Fragment>
      )
   }

   const riskOfExclusionFieldset = () =>
   {
      return (
         <FieldsetContainer title='Risk Of Exclusion'>
            <BootstrapRow>
               {isRiskOfExclusionSection()}
               {fromDateRow()}
            </BootstrapRow>
         </FieldsetContainer>
      )
   }

      return (
         <BootstrapRow>
            <BootstrapCol width={12}>
               { isPost16() === false && riskOfExclusionFieldset() }
            </BootstrapCol>
         </BootstrapRow>
      )
})

export default RiskOfExclusionForm;
